import React, { Component } from 'react';
import LoginPageContainer from '../LoginPageContainer';
import { connect } from 'react-redux';
import { signIn } from '../../../store/actions/authActions';
import { Tabs, Alert, Spin } from 'antd';
import { getGoogleClient, loadGoogleIdentity } from '../../../Helpers/googleSignIn';
const TabPane = Tabs.TabPane;

// Google is the only way in: one click on Google's button, the backend checks the
// token (Loginmodel::google_login) and the session lasts 24 hours.
class LoginForm extends Component {
  state = {
    buttonReady: false,
    signingIn: false,
    setupError: null
  }

  buttonRef = React.createRef();

  componentWillMount() {
    document.title = this.props.title;
  }

  componentDidMount() {
    Promise.all([getGoogleClient(), loadGoogleIdentity()])
      .then(([client, google]) => {
        if (this.unmounted || !this.buttonRef.current) return;
        google.accounts.id.initialize({
          client_id: client.client_id,
          hd: client.domain,
          auto_select: false,
          ux_mode: 'popup',
          callback: (res) => this.handleCredential(res.credential)
        });
        google.accounts.id.renderButton(this.buttonRef.current, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
          shape: 'rectangular',
          logo_alignment: 'left',
          width: Math.min(this.buttonRef.current.offsetWidth || 400, 400)
        });
        this.setState({ buttonReady: true });
      })
      .catch((err) => {
        if (!this.unmounted) this.setState({ setupError: err.message });
      });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleCredential = (credential) => {
    this.setState({ signingIn: true });
    this.props.signIn({ credential }).then(() => {
      if (!this.unmounted) this.setState({ signingIn: false });
    });
  }

  render() {
    const { authError } = this.props;
    const { buttonReady, signingIn, setupError } = this.state;
    return (
      <LoginPageContainer>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Log In To vFulfill Admin" key="1">
            <div className="login-form">
              <p className="google-signin-note">
                Use your vfulfill.io Google account. No password to remember.
              </p>
              {authError && <Alert message={authError} type="error" />}
              {setupError && <Alert message={setupError} type="error" />}
              <Spin spinning={!setupError && (!buttonReady || signingIn)}>
                <div ref={this.buttonRef} className="google-signin" />
              </Spin>
            </div>
          </TabPane>
        </Tabs>
      </LoginPageContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
